export function fetchQuickLinks(apiUrl, accessToken, userId) {
    return fetch(`${apiUrl}/v1/quicklinks/${userId}`, {
        headers: {
            "Authorization": `Bearer ${accessToken}`
        },
    });
}
export function updateQuickLinks(apiUrl, accessToken, userId, drupalUserId, newQuickLinks) {
    return fetch(`${apiUrl}/v1/quicklinks/${userId}`, {
        method: 'PATCH',
        headers: {
            "Authorization": `Bearer ${accessToken}`,
            "Content-Type": 'application/json',
        },
        body: JSON.stringify({
            drupalUserId: drupalUserId,
            links: newQuickLinks
        })
    });
}
